import React from "react";
import { NakiNigunAlbumUnavailableInAppTemplate } from "themes/application/common/components";

function NakiNigunAlbumUnavailableInApp(props) {
    return <NakiNigunAlbumUnavailableInAppTemplate {...props} />;
}

export default NakiNigunAlbumUnavailableInApp;
